<template>
  <div class="products">
    <!-- Hero Section -->
    <div class="hero-section">
      <div class="hero-content">
        <div class="hero-text">
          <h1>华视数科</h1>
          <p>快速了解集团发展历程</p>
        </div>
        <div class="hero-image">
          <img src="https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/top.png" alt="AI产品服务" class="ai-character" />
        </div>
      </div>
    </div>
    
    <!-- 企业简介 -->
    <div id="digital-human" class="digital-human-section">
      <div class="container">
        <!-- 导航栏 -->
        <div class="nav-bar">
          <div 
            class="nav-item" 
            :class="{ active: activeNavItem === 'digital-human' }"
            @click="setActiveNavItem('digital-human')">
            企业简介
          </div>
          <div 
            class="nav-item" 
            :class="{ active: activeNavItem === 'video-service' }"
            @click="setActiveNavItem('video-service')">
            发展历程
          </div>
          <div 
            class="nav-item" 
            :class="{ active: activeNavItem === 'interaction-system' }"
            @click="setActiveNavItem('interaction-system')">
            企业资质
          </div>
          <div 
            class="nav-item" 
            :class="{ active: activeNavItem === 'aigc-video' }"
            @click="setActiveNavItem('aigc-video')">
            合作伙伴
          </div>
          <div 
            class="nav-item" 
            :class="{ active: activeNavItem === 'ai-secretary' }"
            @click="setActiveNavItem('ai-secretary')">
            加入我们
          </div>
        </div>
        
        <!-- 主要内容区域 -->
        <div class="main-content">
          <!-- 顶部标题区域 -->
          <div class="title-section">
            <div class="main-title">
              <h1>企业简介</h1>
            </div>
          </div>
          
          <!-- 中间内容区域 -->
          <div class="content-middle">
            <img src="https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/huazhong.png" alt="华中融媒体生态产业集团" class="main-image">
          </div>
          
          <!-- 底部描述 -->
          <div class="description-section">
            <p>华视集团是中国文化产业新领军企业,中国广告一级企业、国家级高新技术企业、中国AAA级信用企业和专精特新"小巨人"企业。公司成立于2012年,主营文化产业和数字经济业务,全球总部位于中国香港,中国总部位于湖北武汉,在全国设有13个分子公司。</p>
            <p>拥有品牌战略、广告创意、数字营销、大数据智库、AI科技五大核心优势,汇聚国内顶尖高校研究资源和营销实战专家团队,为客户提供全生命周期的创意解决方案和整合营销服务。为客户构建企业战略、品牌咨询、数据分析、创意输出、营销传播的生态闭环,实现商业价值可持续增长。</p>
            <p>公司旗下华视集团控股有限公司于2023年11月10日在香港联合交易所主板上市,股票代码:1111.HK,</p>
          </div>
          
          <!-- 底部图片 -->
          <div class="bottom-image-section">
            <img src="@/assets/image/about/2.png" alt="华视集团和华视数科" class="bottom-image">
          </div>
        </div>
      </div>
    </div>

    <!-- 发展历程 -->
    <div id="video-service" class="video-service-section">
      <div class="container">
        <div class="title-section">
          <div class="main-title">
            <h1>发展历程</h1>
          </div>
        </div>
        <!-- 中间内容区域 -->
        <div class="content-middle">
          <img src="@/assets/image/about/3.png" alt="华中融媒体生态产业集团" class="main-image">
        </div>
      </div>
    </div>

    <!-- 企业优势 -->
    <div id="interaction-system" class="company-advantages-section">
      <div class="container">
        <!-- 顶部标题区域 -->
        <div class="title-section">
          <div class="main-title">
            <h1>企业优势</h1>
          </div>
        </div>
        <!-- 优势卡片区域 -->
        <div class="advantages-cards-container">
          <div class="advantage-card">
            <div class="advantage-number">13年</div>
            <div class="advantage-description">行业服务经验</div>
          </div>
          <div class="advantage-card">
            <div class="advantage-number">100+</div>
            <div class="advantage-description">百亿级合作客户数量</div>
          </div>
          <div class="advantage-card">
            <div class="advantage-number">1000+</div>
            <div class="advantage-description">累计合作客户数量</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 企业资质 -->
    <div class="company-advantages">
      <div class="container">
        <div class="title-section">
          <div class="main-title">
            <h1>企业资质</h1>
          </div>
        </div>
        <!-- 中间内容区域 -->
        <div class="content-middle">
          <img src="https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/honor.png" alt="企业资质" class="main-image">
        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div id="aigc-video" class="video-service-section">
      <div class="container">
        <div class="title-section">
          <div class="main-title">
            <h1>合作伙伴</h1>
          </div>
        </div>
        <!-- 中间内容区域 -->
        <div class="content-middle">
          <img src="@/assets/image/pattern.png" alt="合作伙伴" class="main-image"/>
        </div>
      </div>
    </div>

    <!-- 加入我们 -->
    <div id="ai-secretary" class="join-us-section">
      <div class="container">
        <div class="join-us-content">
          <div class="title-section">
            <div class="main-title">
              <h1>加入我们</h1>
              <!-- <p>填写表格 我们的团队会在24h内联系您！</p> -->
            </div>
          </div>
          
          <!-- 主要内容区域 -->
          <div class="join-us-content">
            <!-- 左侧联系信息 -->
            <div class="contact-info">
              <div class="contact-item">
                <div class="contact-icon">
                  <img src="@/assets/image/about/icon1.png" alt="邮箱图标" />
                </div>
                <div class="contact-text">HS-rlzyb@hsjtkg.com</div>
              </div>
              <div class="contact-item">
                <div class="contact-icon">
                  <img src="@/assets/image/about/icon2.png" alt="电话图标" />
                </div>
                <div class="contact-text">+027 8771 5115</div>
              </div>
              <div class="contact-item">
                <div class="contact-icon">
                  <img src="@/assets/image/about/icon3.png" alt="地址图标" />
                </div>
                <div class="contact-text">武汉市武昌区东湖南路7号</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧联系表单 -->
        <!-- <div class="contact-form">
          <form @submit.prevent="submitForm">
            <div class="form-row">
              <div class="form-group">
                <label for="name">姓名</label>
                <input type="text" id="name" v-model="formData.name" placeholder="XXX" required>
              </div>
              
              <div class="form-group">
                <label for="email">邮箱</label>
                <input type="email" id="email" v-model="formData.email" placeholder="abcd@163.com" required>
              </div>
            </div>
            
            <div class="form-group">
              <label for="phone">电话</label>
              <input type="tel" id="phone" v-model="formData.phone" placeholder="12345678000" required>
            </div>
            
            <div class="form-group">
              <label for="service">选择您要咨询的服务</label>
              <select id="service" v-model="formData.service" required>
                <option value="">请选择服务</option>
                <option value="digital-human">数字人形象定制服务</option>
                <option value="video-service">数字人短视频服务</option>
                <option value="interaction-system">数字人交互系统</option>
                <option value="aigc-video">AIGC视频生成系统</option>
              </select>
            </div>
            
            <button type="submit" class="submit-btn">发送</button>
          </form>
        </div> -->
      </div>
    </div>

    <!-- 模态框 -->
    <div v-if="showImageModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <button class="close-btn" @click="closeModal">&times;</button>
        <img :src="modalImageSrc" :alt="modalImageAlt" class="modal-image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      showImageModal: false,
      modalImageSrc: '',
      modalImageAlt: '',
      selectedCard: 'knowledge', // 默认选中知识科普卡片
      activeNavItem: 'digital-human', // 默认选中数字人形象定制
      formData: {
        name: '',
        email: '',
        phone: '',
        service: ''
      },
      serviceImages: {
        service1: {
          src: require('@/assets/image/products/service1.png'),
          alt: '政策解读大图'
        },
        service2: {
          src: require('@/assets/image/products/service2.png'),
          alt: '产品介绍大图'
        },
        service3: {
          src: require('@/assets/image/products/service3.png'),
          alt: '矩阵打造大图'
        }
      },
    }
  },
  mounted() {
    // 进入关于页面时滚动到顶部
    this.scrollToTop()
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    selectCard(cardType) {
      this.selectedCard = cardType
    },
    setActiveNavItem(item) {
      this.activeNavItem = item
      // 滚动到对应的内容区域
      this.scrollToSection(item)
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    showModal(serviceType) {
      const service = this.serviceImages[serviceType]
      if (service) {
        this.modalImageSrc = service.src
        this.modalImageAlt = service.alt
        this.showImageModal = true
        document.body.style.overflow = 'hidden' // 防止背景滚动
      }
    },
    closeModal() {
      this.showImageModal = false
      document.body.style.overflow = 'auto' // 恢复滚动
    },
    submitForm() {
      // 这里可以添加表单提交逻辑
      console.log('Form submitted:', this.formData)
      alert('感谢您的提交！我们会在24小时内联系您。')
      
      // 重置表单
      this.formData = {
        name: '',
        email: '',
        phone: '',
        service: ''
      }
    }
  }
}
</script>

<style scoped>
.products {
  min-height: 100vh;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(#93BEEB 0%, #F0F7FD 100%);
  position: relative;
  overflow: hidden;
}

.hero-content {
  margin-left: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 2;
  min-height: 400px;
}

.hero-text {
  flex: 1;
  max-width: 40%;
  position: relative;
  z-index: 10;
}

.hero-text h1 {
  color: #2c3e50;
  margin-bottom: 20px;
  width: 256px;
  height: 84px;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 64px;
  line-height: 84px;
  color: #222222;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.hero-text p {
  font-size: 1.2rem;
  color: #2c3e50;
  line-height: 1.6;
  max-width: 500px;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  color: #333333;
  white-space: nowrap;
  overflow: visible;
  margin-bottom: 10px;
  position: relative;
  z-index: 11;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.hero-image {
  position: relative;
  height: 400px;
  flex-shrink: 0;
  z-index: 1;
}

.ai-character {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  transform: scaleX(-1);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* 数字人形象定制系统样式 */
.digital-human-section {
  /* padding: 40px 0; */
  margin-top: 20px;
  border-radius: 20px;
}

.nav-bar {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.nav-item {
  color: #999999;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  padding: 12px 0px 0px;
  width: 90px;
  height: 44px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex: none;
  order: 0;
  flex-grow: 0;
  white-space: nowrap;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.3);
}

.nav-item.active {
  color: #045FB2;
  width: 105px;
  height: 44px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  position: relative;
}

.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 2px;
  background-color: #045FB2;
  border-radius: 1px;
}

.main-content {
  background: white;
  /* padding: 40px; */
  color: #000;
}

.title-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.main-title h1 {
  position: relative;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 38px;
  line-height: 56px;
  letter-spacing: -0.015em;
  color: #292D33;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.main-title h1::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 47px;
  transform: translateX(-50%);
  width: 85px;
  height: 4px;
  background: #0460B3;
  border-radius: 2px;
}

.main-title p {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 33px;
  letter-spacing: -0.015em;
  color: #9497A1;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin-top: 40px;
}

.content-middle {
  margin-bottom: 60px;
  text-align: center;
}

.main-image {
  max-width: 100%;
  height: auto;
}

.description-section {
  padding: 30px 0;
  border-radius: 15px;
}

.description-section p {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 33px;
  letter-spacing: -0.015em;
  color: #9497A1;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.bottom-image-section {
  display: flex;
  justify-content: center;
}

.bottom-image {
  height: auto;
  width: 300px;
  opacity: 0.3;
}

/* 数字人短视频服务样式 */
.video-service-section {
  /* padding: 60px 0; */
}

.company-advantages {
  padding: 60px 0;
  background: linear-gradient(#F0F7FD, #93BEEB);
}

.company-advantages .content-middle {
  padding: 0 60px;
}

/* 企业优势样式 */
.company-advantages-section {
  /* padding: 80px 0; */
  background: linear-gradient(#F5F7FA, #EEF6FD);
}

.advantages-title-section {
  text-align: center;
  margin-bottom: 60px;
}

.advantages-main-title h1 {
  position: relative;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 64px;
  letter-spacing: 0.05em;
  color: #292D33;
  margin: 0;
}

.advantages-cards-container {
  display: flex;
  justify-content: center;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.advantage-card {
  padding: 40px 30px;
  text-align: center;
  background: #FFFFFF;
  box-shadow: 0px 4px 12px rgba(12, 68, 204, 0.1);
  border-radius: 6px;
  transition: all 0.3s ease;
  min-width: 200px;
  flex: 1;
  max-width: 300px;
}

.advantage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.advantage-number {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 64px;
  color: #0460B3;
  margin-bottom: 15px;
}

.advantage-description {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  /* identical to box height, or 175% */
  text-align: center;
  letter-spacing: -0.015em;
  color: #9497A1;
}

/* 加入我们样式 */
.join-us-section {
  padding: 80px 0;
  background: #F5F7FA;
  .container {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}

.join-us-header {
  text-align: center;
  margin-bottom: 60px;
}

.join-us-header h1 {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 64px;
  color: #292D33;
  margin: 0 0 20px 0;
  position: relative;
}

.join-us-header h1::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: #0460B3;
  border-radius: 2px;
}

.join-us-header p {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #666666;
  margin: 0;
}

.join-us-content {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.contact-info {
  flex: 1;
  display: flex;
  /* flex-direction: column; */
  gap: 30px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 15px;
}

.contact-icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.contact-text {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #292D33;
}

.contact-form {
  flex: 1;
}

.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 25px;
}

.form-row .form-group {
  flex: 1;
  margin-bottom: 0;
}

.form-group {
  margin-bottom: 25px;
}

.form-group label {
  display: block;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #292D33;
  margin-bottom: 8px;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 12px 0;
  border: none;
  border-bottom: 1px solid #e0e0e0;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #292D33;
  background: transparent;
  outline: none;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group select:focus {
  border-bottom-color: #0460B3;
}

.submit-btn {
  background: linear-gradient(135deg, #93BEEB 0%, #8DA4FF 100%);
  color: white;
  border: none;
  padding: 15px 40px;
  border-radius: 8px;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  float: right;
  margin-top: 20px;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(147, 190, 235, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-content {
    flex-direction: column;
    text-align: center;
    margin-left: 5%;
    padding: 20px 0;
  }
  
  .hero-text {
    max-width: 100%;
    margin-bottom: 20px;
  }
  
  .hero-text h1 {
    font-size: 2.5rem;
    width: auto;
  }
  
  .hero-text p {
    white-space: normal;
    max-width: 100%;
  }
  
  .hero-image {
    width: 250px;
    height: 300px;
    margin-top: 30px;
    margin-left: 0;
  }
  
  .nav-bar {
    gap: 15px;
  }
  
  .nav-item {
    font-size: 0.9rem;
    padding: 6px 12px;
  }
  
  .title-section {
    flex-direction: column;
    gap: 20px;
  }
  
  .main-image {
    border-radius: 10px;
  }

  .advantages-cards-container {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  .advantage-card {
    max-width: 90%;
    min-width: auto;
  }

  .advantages-main-title h1 {
    font-size: 36px;
    line-height: 48px;
  }

  .advantage-number {
    font-size: 36px;
    line-height: 48px;
  }

  .advantage-description {
    font-size: 16px;
    line-height: 22px;
  }

  .join-us-header h1 {
    font-size: 36px;
    line-height: 48px;
  }

  .join-us-header p {
    font-size: 16px;
    line-height: 22px;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }

  .form-row .form-group {
    margin-bottom: 25px;
  }
}

@media (max-width: 480px) {
  .hero-text h1 {
    font-size: 2rem;
  }
  
  .hero-text p {
    font-size: 1rem;
    white-space: normal;
  }
  
  .hero-image {
    width: 200px;
    height: 250px;
  }
}
</style>